import React from "react";
import LegalPage from "../../components/LegalPage";

const PDF = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/2i1r6ucv_Zelaflo_Labs_Cookie_Policy.pdf";

export default function CookiePolicy() {
  return (
    <LegalPage
      title="Cookie Policy"
      pdfUrl={PDF}
      description="How Zelaflo Labs uses cookies and similar tracking technologies across our services."
      testId="legal-cookie-policy"
    />
  );
}
